module.exports = __webpack_public_path__ + "static/media/image01.22269dcb.png";